import React, { useRef } from "react";

import Box from "./Box";
import ItemCondition from "./ItemCondition";
import PropTypes from "prop-types";
import Toggle from "./Toggle";
import { useHovered } from "../core/hooks";
import { useListingsContext } from "./ListingsContext";
import { REPAIRED_FILTER_TYPE } from "../core/constants";

// We would only ever be filtering to show repaired items only or
// turning this filter off to show all items
const REPAIRED_VALUE = { key: "repaired", label: "true", value: "true" };

function RepairedFilter({ showTooltip }) {
  const { setFilter, activeFilters } = useListingsContext();
  const ref = useRef(null);
  const hovered = useHovered(ref);
  const activeFiltersForType = activeFilters.find((activeFilter) => {
    return activeFilter.type === REPAIRED_FILTER_TYPE;
  }) || { options: [] };
  const active =
    activeFiltersForType.options.length === 1 &&
    activeFiltersForType.options[0].label === "true"
      ? true
      : false;

  return (
    <Box
      ref={ref}
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <ItemCondition
        condition={REPAIRED_FILTER_TYPE}
        showTooltip={showTooltip}
        tooltipActive={hovered}
      />
      <Box display="flex" alignItems="center" pl="10px">
        <Toggle
          active={active}
          onClick={() => {
            setFilter(REPAIRED_FILTER_TYPE, REPAIRED_VALUE);
          }}
          ariaLabel="Filter by repaired"
        />
      </Box>
    </Box>
  );
}

export default RepairedFilter;

RepairedFilter.propTypes = {
  showTooltip: PropTypes.bool,
};
